import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-profit")({
  component: lazyRouteComponent(() => import("./-pages/admin.sales-profit")),
  head: () => ({
    meta: [
      { title: "أرباح المبيعات · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
